<template>
  <div class="flex w-full flex-col items-center justify-center gap-4 text-center">
    <img :src="image" :alt="imageAlt" class="h-36 w-auto" />

    <div class="space-y-2">
      <h3 v-if="title" class="text-lg font-semibold text-slate-800">
        {{ title }}
      </h3>
      <p class="text-sm text-slate-500">
        {{ message }}
      </p> 
    </div>
  </div>
</template>

<script>
import illustration from "../../assets/product-we-got-a-problem-01-8.png";

export default {
  name: "EmptyState",
  props: {
    title: {
      type: String,
      default: "Sorry no users was found"
    },
    message: {
      type: String,
      default: "We could not find any related records for this tenant."
    },
    image: {
      type: String,
      default: () => illustration
    },
    imageAlt: {
      type: String,
      default: "Empty state illustration"
    }
  }
};
</script>

<style scoped>
img {
  max-width: 100%;
}
</style>
